<template>
  <div class="child-bg-image">
    <div class="bg-image-section" />
    <div class="content-section">
      <logout-page />
    </div>
  </div>
</template>

<script>
import LogoutPage from '../../auth/Logout.vue';

export default {
  name: 'Organizations',
  components: {
    'logout-page': LogoutPage,
  },
};
</script>

<style scoped>

</style>
